import React from 'react';
import { SvgIcon } from '@mui/material';
import { iconType } from './icon-types';

const DeleteIcon = (properties: iconType) => {
  const { stroke } = properties;
  return (
    <SvgIcon
      {...properties}
      viewBox="0 0 18 18"
      style={{ width: '18px', height: '18px', stroke, fill: 'none' }}
    >
      <path d="M13.3084 15.2792H2.96936V2.96948H13.3084V15.2792Z" />
      <path d="M10.8465 2.96956H5.43085V1H10.8465V2.96956Z" />
      <path d="M1 2.96948H15.2778" />
      <path d="M5.43085 5.67773V12.5712" />
      <path d="M8.13879 5.67773V12.5712" />
      <path d="M10.8467 5.67773V12.5712" />
    </SvgIcon>
  );
};

DeleteIcon.defaultProperties = {
  strokeMiterlimit: '10',
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  stroke: '#A7B0C0',
  width: '18px',
  height: '18px',
};

export default DeleteIcon;
